import script from "./AuthSplitLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthSplitLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthSplitLayout.vue?vue&type=style&index=0&id=6f606f95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f606f95"]])

export default __exports__